import { isMobileOnly } from 'react-device-detect';
import { accountUnlinkMessage, payAndManageUrl } from './constants';

export const getChannelID = () => (isMobileOnly ? 2 : 1);

export const generateXB3TraceID = () => Math.random().toString(16).substring(2)
  + new Date().getTime().toString(16).substring(0, 15);

export const isSsr = typeof window === 'undefined';

export const getHost = () => {
  if (isSsr) return '';

  if (process.env.NODE_ENV === 'production' && !process.env.DOMAIN_NAME) {
    return `https://${window.location.hostname}`;
  }

  return window.location.origin;
};

export const getUrlParam = (key) => {
  const searchParams = typeof window !== 'undefined' ? window?.location?.search : '';
  const urlParams = new URLSearchParams(searchParams);
  return urlParams.get(key);
};

export const getTmxId = () => {
  let nativeTMXID = '';
  if (window.__EXPERIENCE_CONTEXT__?.isConsumerApp) {
    nativeTMXID = getUrlParam('guid');
  }
  return nativeTMXID || window.THD_ACCOUNT_LIB?.TMX?.getTMXsessionId();
};

export const redirectToLogin = () => {
  const ssoredirect = getUrlParam('ssoredirect');
  if (ssoredirect) {
    const siteId = `${ssoredirect}_HOMEDEPOT`;
    const account = Object.keys(accountUnlinkMessage).find((item) => (item === siteId));
    window.location.href = account ? payAndManageUrl[siteId] : payAndManageUrl.PLCN_HOMEDEPOT;
    return;
  }
  const logonPath = '/auth/view/signin?redirect=/myaccount/thdcreditcard';
  const host = (window.THD_GLOBAL && window.THD_GLOBAL.nonSecureHostName)
    ? 'https://' + THD_GLOBAL.nonSecureHostName : 'https://' + window.location.host;
  if (host.includes('www.homedepot.com') || host.includes('hd-qa74.homedepotdev.com')
    || host.includes('hd-qa71.homedepotdev.com')) {
    window.location.href = host + logonPath;
  } else {
    window.location.href = 'https://www.homedepot.com' + logonPath;
  }
};
